import { ArrowRightAltRounded } from '@mui/icons-material'
import { ButtonBase, Card, Stack, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import Business from '../../../../../../api/db/Business'
import { currentAdminbusinessActions } from '../../../../../../store/features/currentBusiness'
import { selectUserPropsState } from '../../../../../../store/features/user'
import { RootState } from '../../../../../../store/store'
import { BagIcon, CoinsIcon, ProfitIcon, StoreIcon } from '../../../../../atoms/icons'
import HeaderSkeleton from '../../../../common/skeletons/HeaderSkeleton'

export default function ContentHeader() {

    const dispatch = useDispatch()
    const userId = useSelector(selectUserPropsState)?.uid ?? ""
    const currentBusinessMetadata = useSelector((state:RootState)=>state.currentBusiness.metaData)


    useEffect(()=>{

        fetchCurrentBusinessMetaData(userId)
    
    // eslint-disable-next-line
    },[])

    const fetchCurrentBusinessMetaData = async (userId:string)=>{
        try {

            const currentBusiness = await Business.getCurrentBusinessMetadata(userId)
            dispatch(currentAdminbusinessActions.setCurrentBusinessMetadata({
                name: currentBusiness.name,
                total_shops: currentBusiness.stats.total_shops,
                best_performing_shop: currentBusiness.stats.best_performing_shop === null ? "Not yet available" : currentBusiness.stats.best_performing_shop,
                gross_revenue: currentBusiness.stats.gross_revenue,
                gross_profit: currentBusiness.stats.gross_profit,
                total_sales: currentBusiness.stats.total_sales
            }))
        } catch (error) {
            toast("Failed to fetch business metadata",{
                position: "top-center",
                autoClose: false,
                className:"text-center",
                type: "error",
                progressClassName: "bg-primary",
                theme: "dark",
                hideProgressBar: true
            })
        }
    }
    
    return (
        <>
            {
                !currentBusinessMetadata?.name ? (
                    <HeaderSkeleton />
                ) : (
                    <Stack direction="row" spacing={2} >

                        <Card variant="outlined" sx={styles.cardMin}>

                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <ProfitIcon />
                                    </div>

                                    <Stack direction="column" textAlign="left" >
                                        <Typography textAlign="left" color={grey[500]}>Gross Revenue</Typography>
                                        <Typography textAlign="left" variant="h6" > GH₵ {currentBusinessMetadata?.gross_revenue}</Typography>
                                    </Stack>

                                </Stack>

                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                            
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <CoinsIcon />
                                    </div>

                                    <Stack direction="column" textAlign="left" >
                                        <Typography color={grey[500]}>Gross Profit</Typography>
                                        <Typography variant="h6" > GH₵ {currentBusinessMetadata?.gross_profit}</Typography>
                                    </Stack>

                                </Stack>

                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                    <ArrowRightAltRounded htmlColor={grey[500]} />
                                </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <StoreIcon />
                                    </div>

                                    <Stack direction="column" textAlign="left" >
                                        <Typography color={grey[500]}>Best Performing Shop</Typography>
                                        <Typography variant="h6" >{currentBusinessMetadata?.best_performing_shop}</Typography>
                                    </Stack>

                                </Stack>

                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >Daily sales report</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>

                        <Card variant="outlined" sx={styles.cardMin} >
                            <Stack direction="column" sx={{height: "100%"}} justifyContent="space-between">

                                <Stack direction="row" spacing={2} >
                                    <div
                                        style={{
                                            width: "18%",
                                            // height: "50px",
                                            padding: "0.5rem",
                                            backgroundColor: 'rgba(255, 255, 255, 0.1)',
                                            borderRadius: "3px"
                                        }}
                                    >
                                        <BagIcon />
                                    </div>

                                    <Stack direction="column" textAlign="left" >
                                        <Typography color={grey[500]}>Total Sales</Typography>
                                        <Typography variant="h6" >{currentBusinessMetadata?.total_sales}</Typography>
                                    </Stack>

                                </Stack>

                                <Stack direction="row" alignItems="center" justifyContent="space-between" >

                                    <Typography color={grey[500]} fontSize="14px" fontWeight="light" >View employee performance</Typography>

                                    <ButtonBase focusRipple={true} sx={{borderRadius: "100%", padding: "4px"}} >
                                        <ArrowRightAltRounded htmlColor={grey[500]} />
                                    </ButtonBase>

                                </Stack>

                            </Stack>
                        </Card>


                    </Stack>
                )
            }
        </>
    )
}

const styles = {

    cardMin:{
        flex: 1, 
        borderRadius: "4px", 
        backgroundColor: 'primary.main',
        // backgroundColor: 'primary.dark',
        border: `.5px solid rgba(255, 255, 255, 0.1)`,
        padding: "1rem"
    },

}
